// extracted by mini-css-extract-plugin
export default {"freeFeatures":"footer_freeFeatures__V+R9n"};